<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { type Props, type Emit, setup } from './userMenuElement.setup';

defineProps<Props>();
const emit = defineEmits<Emit>();

const {
  t,
  userInfo,

  onHoverButton,
  onClickButton,
} = setup(emit);
</script>

<template>
  <li :class="['menu-element', 'user-menu', { selected }]">
    <base-button
      tag="button"
      class="menu-element__title user-menu__title"
      :data-menu="info.value"
      @mouseenter="onHoverButton"
      @click="onClickButton"
    >
      <div class="menu-element__title-inner user-menu__title-inner">
        <div class="menu-element__item-icon">
          <span
            class="user-menu__item-icon"
            :class="userInfo.profileImage"
          />
        </div>
        <h3>{{ t('WORD.PROFILE') }}</h3>
        <div class="menu-element__arrow-icon right" />
      </div>
    </base-button>
  </li>
</template>

<style scoped lang="scss">
.user-menu {
  .base-menu.expanded & {
    width: 100%;
  }

  &__title {
    .base-menu.expanded & {
      width: 100%;
      padding: 8px;
    }
  }

  &__title-inner {
    flex: 1;
    width: 100% !important;
    min-width: 0;
    padding-right: 0;
    padding-left: 0;
  }

  // menu-element__item-icon의 배경색 제거 (프로필 이미지는 배경색 불필요)
  :deep(.menu-element__item-icon) {
    background-color: transparent !important;
  }

  &__item-icon {
    display: block;
    position: relative;
    width: var(--gnb-menu-icon-size);
    min-width: var(--gnb-menu-icon-size);
    max-width: var(--gnb-menu-icon-size);
    height: var(--gnb-menu-icon-size);
    border-radius: 20px;
    background-color: transparent !important;
    background-size: var(--gnb-menu-icon-size) var(--gnb-menu-icon-size);
  }

  &.selected,
  &.selected > .user-menu__title:hover {
    background-color: rgb(var(--color-gray-00-00-rgb), 0.12);
  }
}
</style>
